import { ReactNode } from 'react';
import { Cell, CellProps } from '_common/components/Table';

type StoragePageCellProps = CellProps & {
  children: ReactNode;
  object: Objekt | doDOC.BaseObject;
  testId: string;
};

const StoragePageCell = ({ children, object, testId, ...props }: StoragePageCellProps) => {
  return (
    <Cell {...props} testId={`${object.id}-${testId}`} disabled={object.status === 'processing'}>
      {children}
    </Cell>
  );
};

export default StoragePageCell;
